import { canv } from "@/canv/global.js";
import type { textWidget } from "@/elements/text/text";
import { Shape } from "@/shapeStorage/shapes/shape";

export class ShapeGroup extends Shape {
    width = 191;
    height = 141;
    borderStyleEnabled = false;

    setDrawStyle(_: any): void {}

    fitText(
        textPart: textWidget,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 7) / 8 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + (width * 7) / 8 / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(
        x: number,
        y: number,
        w: number,
        h: number,
        shapeStyles: {
            color: string;
            borderColor: string;
            borderDashType: string;
            borderWidth: number;
        },
    ) {
        const ctx = canv.ctx;
        // соотношение [ш/в] в фигуре 22/16.5
        const scale = w / 22;
        const cornerWLen = 9.5 * scale; // длина углов
        const a = w - cornerWLen * 2;
        const cornerHLen = (h - a) / 2 > 0 ? (h - a) / 2 : a / 8;
        const cr = scale / 3; // радиус круглых узлов

        ctx.save();
        ctx.fillStyle = shapeStyles.color;
        ctx.strokeStyle = shapeStyles.borderColor;
        ctx.lineWidth = shapeStyles.borderWidth;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + cr, y);
        canv.ctx.arcTo(x + w, y, x + w, y + h, cr);
        canv.ctx.arcTo(x + w, y + h, x, y + h, cr);
        canv.ctx.arcTo(x, y + h, x, y, cr);
        canv.ctx.arcTo(x, y, x + w, y, cr);
        canv.ctx.fill();
        canv.ctx.closePath();

        ctx.fillStyle = shapeStyles.borderColor;
        ctx.beginPath();
        // Центра кругов
        const cx = x + w / 2;
        const cy = y + h / 2;
        // в
        ctx.moveTo(cx + cr, y);
        ctx.arc(cx, y, cr, 0, Math.PI * 2);
        // н
        ctx.moveTo(cx + cr, y + h);
        ctx.arc(cx, y + h, cr, 0, Math.PI * 2);
        // л
        ctx.moveTo(x + cr, cy);
        ctx.arc(x, cy, cr, 0, Math.PI * 2);
        // п
        ctx.moveTo(x + w + cr, cy);
        ctx.arc(x + w, cy, cr, 0, Math.PI * 2);
        ctx.fill();
        ctx.stroke();
        ctx.closePath();

        // Углы
        ctx.beginPath();
        // ВЛ
        ctx.moveTo(x + cornerWLen, y);
        ctx.lineTo(x, y);
        ctx.lineTo(x, y + cornerHLen);
        // ВП
        ctx.moveTo(x + w - cornerWLen, y);
        ctx.lineTo(x + w, y);
        ctx.lineTo(x + w, y + cornerHLen);
        // НП
        ctx.moveTo(x + w, y + h - cornerHLen);
        ctx.lineTo(x + w, y + h);
        ctx.lineTo(x + w - cornerWLen, y + h);
        // НЛ
        ctx.moveTo(x + cornerWLen, y + h);
        ctx.lineTo(x, y + h);
        ctx.lineTo(x, y + h - cornerHLen);
        ctx.stroke();
        ctx.closePath();
        ctx.restore();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg fill="none" width="${width}" height="${height}" viewBox="0 0 22 16" xmlns="http://www.w3.org/2000/svg">
                <g fill="${stroke}">
                    <path d="m11 12.9072c.7409.0001 1.3418.6009 1.3418 1.3418-.0001.7409-.6009 1.3417-1.3418 1.3418-.7409 0-1.34172-.6009-1.3418-1.3418 0-.741.6008-1.3418 1.3418-1.3418z"/>
                    <path d="m2.0918 13.5h5.71972v1.5h-6.46972c-.413981-.0002-.749894-.336-.750003-.75v-3.2109h1.500003z"/>
                    <path d="m21.4092 14.25c-.0001.1988-.0791.3897-.2197.5303-.1407.1406-.3315.2197-.5303.2197h-6.4238v-1.5h5.6738v-2.4609h1.5z"/>
                    <path d="m1.3418 6.41406c.74091.00008 1.34179.60087 1.34179 1.3418-.00007.74087-.60092 1.34172-1.34179 1.3418-.740935 0-1.3417254-.60089-1.3418-1.3418 0-.74098.600819-1.3418 1.3418-1.3418z"/>
                    <path d="m20.6582 6.41406c.7409.00008 1.3418.60087 1.3418 1.3418-.0001.74087-.6009 1.34172-1.3418 1.3418-.7409 0-1.3417-.60089-1.3418-1.3418 0-.74098.6008-1.3418 1.3418-1.3418z"/>
                    <path d="m7.81152 2.01367h-5.71972v2.5918h-1.500003v-3.3418c0-.414089.335955-.7498.750003-.749998h6.46972z"/>
                    <path d="m20.6592.513672c.1989 0 .3896.079074.5303.219726.1406.140653.2197.331362.2197.530272v3.3418h-1.5v-2.5918h-5.6738v-1.499998z"/>
                    <path d="m11 0c.7409.0000746 1.3418.600865 1.3418 1.3418-.0001.74087-.6009 1.34172-1.3418 1.34179-.7409 0-1.34172-.60088-1.3418-1.34179 0-.740981.6008-1.3418 1.3418-1.3418z"/>
                </g>
            </svg>
        `;
    }
}
